import axios from "axios";
import _Util from "../helper/_Util";
import { message } from "antd";

const URI_API = process.env.REACT_APP_URL_API;

const search = async () => {
  try {
    let result = await axios.get(`${URI_API}/mgt-org/search`, {
      withCredentials: true,
    });
    return result.data.data;
  } catch (err) {
    _Util.handleAxiosStatus(err.response.status, err.response.data.msg);
    return [];
  }
};

const detail = async (orgId) => {
  try {
    let result = await axios.get(`${URI_API}/mgt-org/detail/${orgId}`, {
      withCredentials: true,
    });
    if (result.data.status) {
      return result.data.data;
    } else {
      message.error(result.data.msg);
      return false;
    }
  } catch (err) {
    _Util.handleAxiosStatus(err.response.status, err.response.data.msg);
    return false;
  }
};

const create = async (data) => {
  try {
    let result = await axios.post(`${URI_API}/mgt-org/create/`, data, {
      withCredentials: true,
    });
    if (result.data.status) {
      return result.data.data;
    } else {
      return false;
    }
  } catch (err) {
    _Util.handleAxiosStatus(err.response.status, err.response.data.msg);
    return false;
  }
};

const update = async (userId, data) => {
  try {
    let result = await axios.put(`${URI_API}/mgt-org/${userId}`, data, {
      withCredentials: true,
    });
    if (result.data.status) {
      return result.data.data;
    } else {
      return false;
    }
  } catch (err) {
    _Util.handleAxiosStatus(err.response.status, err.response.data.msg);
    return false;
  }
};

const deleteOrg = async (userId) => {
  try {
    let result = await axios.delete(`${URI_API}/mgt-org/${userId}`, {
      withCredentials: true,
    });
    if (result.data.status) {
      return result.data.data;
    } else {
      message.error(result.data.msg);
      return false;
    }
  } catch (err) {
    _Util.handleAxiosStatus(err.response.status, err.response.data.msg);
    return false;
  }
};

const MgtOrgService = {
  search: search,
  detail: detail,
  create: create,
  update: update,
  delete: deleteOrg,
};

export default MgtOrgService;
